const commonStrings = {
  sidebar: {
    logoImageAltText: 'vezeeta logo',
    ordersItemName: 'Orders',
    labsItemName: 'Labs',
    masterListItemName: 'Master List',
  },

  header: {
    userNameText: 'Hi,',
    logoutText: 'Logout',
  },
};

export default commonStrings;
